// Pure maths for the scrubber: a static wave of the whole clip.

// Bars are 2px wide with a 2px gap; their count follows the measured width.
export const BAR_GAP = 2;
export const BAR_WIDTH = 2;
// Seconds the skip buttons and the slider's arrow keys move by.
export const SKIP_SECONDS = 15;
// A status within this many seconds of the seek target counts as arrived.
export const SEEK_SETTLE_TOLERANCE_S = 0.5;
// Give up waiting for the player to reach a seek target after this long.
export const SEEK_TIMEOUT_MS = 1500;
// How long play may wait for the audio to become playable before giving up.
export const LOAD_TIMEOUT_MS = 10000;
// Finishing this close to the end counts as done: playback restarts from 0.
export const END_RESET_S = 0.75;

export function barCount(width) {
  return Math.max(0, Math.floor((width + BAR_GAP) / (BAR_WIDTH + BAR_GAP)));
}

export function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

// Clamps a position to [0, duration]; an unknown (0) duration only floors at 0.
export function clampPosition(seconds, duration) {
  const s = Math.max(0, seconds);
  return duration > 0 ? Math.min(duration, s) : s;
}

// The position under x px of a `width`-px wave of the whole clip.
export function offsetToPosition(x, width, duration) {
  if (width <= 0) return 0;
  return clamp(x / width, 0, 1) * duration;
}
